module.exports = __webpack_public_path__ + "media/images/konintodoke/banner/banner_chapel-photo-e3f216f7381395bde38f02ab7b18495f.png";